<template>
  <v-container fluid>
    <v-card class="my-8" elevation="3">
      <v-card-title>
        <v-icon class="mr-2" color="primary">mdi-account-group</v-icon>
        <span class="text-h6 font-weight-bold">Clients</span>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="clients"
        :loading="loading"
        class="elevation-1"
        item-key="clientId"
        density="comfortable"
        loading-text="Loading clients…"
        no-data-text="No clients found."
        hide-default-footer
        striped
      >
        <template #item.clientId="{ item }">
          <v-chip color="primary" variant="elevated" size="small">{{ item.clientId }}</v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";

const loading = ref(true);
const clients = ref([]);

const headers = [
  { text: "Client ID", value: "clientId", width: 120 },
  { text: "Name", value: "name" },
  { text: "Customer ID", value: "customerId", width: 140 },
];

onMounted(async () => {
  try {
    const { data } = await axios.get("https://localhost:7188/api/Client/GetClientData");
    clients.value = data;
  } catch (err) {
  } finally {
    loading.value = false;
  }
});
</script>
